import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import AuthCallback from './AuthCallback'
import LandingPage from './components/LandingPage'
import TestPage from './components/TestPage'
import SimpleHero from './components/SimpleHero'
import EmailConfirmation from './components/EmailConfirmation'
import TermsPage from './components/TermsPage'
import PrivacyPage from './components/PrivacyPage'
import DisclaimerPage from './components/DisclaimerPage'
import ContactPage from './components/ContactPage'

function App() {
return (
<Router>
<Routes>
<Route path="/" element={<LandingPage />} />
<Route path="/test" element={<TestPage />} />
<Route path="/simple" element={<SimpleHero />} />
<Route path="/landing" element={<LandingPage />} />
<Route path="/auth/callback" element={<AuthCallback />} />
<Route path="/email-confirmed" element={<EmailConfirmation />} />
<Route path="/terms" element={<TermsPage />} />
<Route path="/privacy" element={<PrivacyPage />} />
<Route path="/disclaimer" element={<DisclaimerPage />} />
<Route path="/contact" element={<ContactPage />} />
<Route path="*" element={<Navigate to="/" replace />} />
</Routes>
</Router>
)
}

export default App
